import { render } from "./ChoosePassengers.vue?vue&type=template&id=565ba968&scoped=true"
import script from "./ChoosePassengers.vue?vue&type=script&lang=js"
export * from "./ChoosePassengers.vue?vue&type=script&lang=js"

import "./ChoosePassengers.vue?vue&type=style&index=0&id=565ba968&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565ba968"]])

export default __exports__